import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect, useRef, memo } from "react";

import { useGame } from "../header/GameContext";
import { CHAT_DATA } from "../chat/chatData";
import Header from "../header/header";
import ChatBoxType2 from "../chat/chatType2";
import QuizeCheck from "./quizeCheck";
import Wrong from "../wrong/wrong";
import Hint from "../hint/hint";

import "./quiz.css";

// 🔥 memo로 감싸서 부모 리렌더 시 불필요한 재실행 차단
export default memo(function Quize() {
  const location = useLocation();
  const navigate = useNavigate();

  const { TOTAL_GAME_TIME, isFinalQuiz, isLastQuiz, userRole } = useGame();

  const [showWrong, setShowWrong] = useState(false);
  const [hintWhether, setHintWhether] = useState(false);
  const [showHint, setShowHint] = useState(false);

  const chatRef = useRef(null);

  const state = location.state || {};
  const { answerData, DateVal, titImgClass, hintWhetherIs, hintContent } =
    state;

  // 🔥 useMemo 대신 변수로 고정 (state는 라우팅 시 고정값)
  let userRoleChatData;
  if (isFinalQuiz(answerData) || isLastQuiz(answerData)) {
    userRoleChatData = CHAT_DATA[DateVal];
  } else {
    userRoleChatData = CHAT_DATA[DateVal]?.[userRole];
  }

  useEffect(() => {
    setHintWhether(hintWhetherIs);
  }, [hintWhetherIs]);

  return (
    <div id="content">
      <Header
        initialTime={TOTAL_GAME_TIME}
        missionCount={3}
        missionTotal={8}
        backBtnView={!isFinalQuiz(answerData)}
      />

      <div className="box box_con con_box1 con_pd5 con_box_c ans0001">
        <div className={`mission_tit ${titImgClass}`}>
          {hintWhether && (
            <a className="hint_d" onClick={() => setShowHint(true)}>
              <span className="hint_in hint_icon mr4"></span>
              <span className="hint_in hint_txt">힌트보기</span>
            </a>
          )}
        </div>

        <ChatBoxType2
          DateVal={userRoleChatData}
          titImgClass={titImgClass}
          timerMode="run"
          ref={chatRef}
        />

        <QuizeCheck
          onWrong={() => setShowWrong(true)}
          answerData={answerData}
        />

        {showWrong && <Wrong onClose={() => setShowWrong(false)} />}
        {showHint && (
          <Hint hintContent={hintContent} onClose={() => setShowHint(false)} />
        )}
      </div>
    </div>
  );
});
